import { render } from "./Tiendas.vue?vue&type=template&id=0766a2ad&scoped=true"
import script from "./Tiendas.vue?vue&type=script&lang=ts"
export * from "./Tiendas.vue?vue&type=script&lang=ts"

import "./Tiendas.vue?vue&type=style&index=0&id=0766a2ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0766a2ad"

export default script